<template>
  <div class="wrapper">
    <div class="wrapper-content">
      <van-cell-group>
        <van-cell title="头像">
          <template #default>
            <van-image :src="getAvatar()" lazy-load round class='avatar' fit="cover">
              <template #error>
                <van-image :src="require('@/assets/logo.png')" fit="cover"></van-image>
              </template>
            </van-image>
          </template>
        </van-cell>
        <van-cell title="昵称" :value='nickname()'/>
        <van-cell title="设置密码" is-link value='' to="/mine/changePass"/>
      </van-cell-group>
    </div>
    <van-button type="info" round @click="handleLogout" block>退出登陆</van-button>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Mine',
  data () {
    return {
      show: true,
      text: null
    }
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar', 'userInfo']),
    getAvatar () {
      console.log('url = ' + window._CONFIG.staticDomainUrl + '/' + this.avatar())
      return window._CONFIG.staticDomainUrl + '/' + this.avatar()
    },
    handleLogout () {
      const that = this

      Dialog.confirm({
        title: '提示',
        message: '确认注销登录吗 ?'
      }).then(() => {
        return that.Logout({}).then(() => {
          window.location.href = '/'
        }).catch(err => {
          Toast.fail({
            message: err.message
          })
        })
      }).catch(() => {
        // on cancel
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .wrapper{
    margin: 20px 15px 0px 15px;
    .wrapper-content {
      margin-bottom: 20px;
    }
  }
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
  }
</style>
